export const logos = [
  {
    src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-white.svg',
    alt: 'Samsung',
  },
  {
    src: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/verivox-white.svg',
    alt: 'Verivox',
  },
  {
    src: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/tui/tui-logo-white.svg',
    alt: 'TUI',
  },
];
